import { Routes } from '@angular/router';
import { MyAccountComponent } from './account/my-account.component';
import { ElectionHistoryComponent } from './elections/election-history.component';
import { CriticalErrorComponent } from './error/critical-error.component';
import { VotingComponent } from './voting/voting.component';

const votingRouteData = {
  title: 'Votação da CIPA',
  subtitle: '',
  showContentHeader: false,
  contentsPath: [],
};

export const routes: Routes = [
  {
    path: '',
    component: VotingComponent,
    data: votingRouteData,
  },
  {
    path: 'votacao',
    component: VotingComponent,
    data: votingRouteData,
  },
  {
    path: ':companySuffix/:electionGuid',
    component: VotingComponent,
    data: votingRouteData,
  },
  {
    path: 'eleicoes',
    component: ElectionHistoryComponent,
    data: {
      title: 'Histórico de Eleições',
      subtitle: 'Consulte as eleições da CIPA vinculadas à sua participação e acompanhe os resultados disponíveis.',
      showContentHeader: true,
      contentsPath: [
        { name: 'Eleições', path: '/eleicoes' },
      ],
    },
  },
  {
    path: 'eleicoes/:companySuffix/:electionGuid',
    component: VotingComponent,
    data: {
      title: 'Resultado da Eleição',
      subtitle: 'Acompanhe o resumo das informações e do resultado desta eleição da CIPA.',
      showContentHeader: true,
      contentsPath: [
        { name: 'Eleições', path: '/eleicoes' },
        { name: 'Resultado', path: '/eleicoes/:companySuffix/:electionGuid' },
      ],
    },
  },
  {
    path: 'conta',
    component: MyAccountComponent,
    data: {
      title: 'Minha Conta',
      subtitle: 'Consulte seus dados básicos e atualize o e-mail ou a senha de acesso ao sistema.',
      showContentHeader: true,
      contentsPath: [
        { name: 'Minha Conta', path: '/conta' },
      ],
    },
  },
  {
    path: 'erro/:code',
    component: CriticalErrorComponent,
    data: {
      title: 'Erro na Aplicação',
      subtitle: '',
      showContentHeader: false,
      contentsPath: [],
    },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
